import {
  GET_FABRIC_RESOURCE,
  GET_FABRIC_RESOURCE_SUCCESS,
  GET_FABRIC_RESOURCE_ERROR,
} from "./actionTypes"

export const getFabricResource = data => ({
  type: GET_FABRIC_RESOURCE,
  payload: data,
})

export const getFabricResourceSuccess = data => ({
  type: GET_FABRIC_RESOURCE_SUCCESS,
  payload: data,
})

export const getFabricResourceError = data => ({
  type: GET_FABRIC_RESOURCE_ERROR,
  payload: data,
})
